import * as THREE from 'three';
import { createTargetSprite } from './sprite';

export class ProjectorTarget extends THREE.Object3D {
  constructor(projector) {
    super();

    // Create visual sprite
    const targetSprite = createTargetSprite();

    // Create invisible sphere for raycasting/selection
    const targetSphereGeometry = new THREE.SphereGeometry(0.7, 8, 8);
    const targetSphereMaterial = new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0,
      depthTest: false,
    });
    const targetSelectionSphere = new THREE.Mesh(targetSphereGeometry, targetSphereMaterial);

    targetSelectionSphere.layers.set(1);
    targetSelectionSphere.userData.isProjectorTarget = true;
    targetSelectionSphere.userData.projectorOverlayIgnore = true;
    targetSelectionSphere.renderOrder = 999;

    this.add(targetSprite);
    this.add(targetSelectionSphere);

    // Expose the selection sphere's userData on the group for compatibility
    // this.userData.isProjectorTarget = true
    this.userData.selectable = true;
    this.userData.projectorCode = projector.userData.code;
    this.userData.isProjectorTarget = true;
    this.userData.code = projector.userData.code + '-target';
    this.userData.projectorOverlayIgnore = true;

    return this;
  }

  setSelected(selected) {
    this.userData.selected = selected;
  }

  isSelected() {
    return this.userData.selected;
  }

  select() {
    this.setSelected(true);
  }

  clearSelection() {
    this.setSelected(false);
  }
}
